const preferenceService = {
    get: (key) => {
        return JSON.parse(localStorage.getItem(key) || '{}');
    },
    currentUser: () => {
        return JSON.parse(localStorage.getItem('userDetails') || '{}');
    },
    set: (data, key) => {
        localStorage.setItem(key || 'userDetails', JSON.stringify(data));
    },
    token: () => {
        return preferenceService.currentUser().token
    },
    screenView: () => {
        return JSON.parse(localStorage.getItem('mobileView') || false);
    },
    clearLocal: () => {
        localStorage.removeItem('userDetails');
        localStorage.removeItem('userPermission');
    },
    getACL: () => {
        return JSON.parse(localStorage.getItem('userPermission') || '[]');
    },
    hasAccess: (module, resource) => {
        if (preferenceService.currentUser().roles === 'SUPER_ADMIN') {
            return true;
        }
        const aclData = preferenceService.getACL() || [];
        return aclData.some(e => {
            return e.module === module && e.resource === resource;
        });
    },
    hasModule: (module) => {
        if (preferenceService.currentUser().roles === 'SUPER_ADMIN') {
            return true;
        }
        const aclData = preferenceService.getACL() || [];
        return aclData.some(e => {
            return e.module === module;
        });
    }
}

export {
    preferenceService
}
